<template>
  <div >
    <!-- <Navbar />
    <Sidebar /> -->
    <section class="main no-flex">

      <MaterialVariantLocationListing />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/sidebars/Sidebar.vue'
import Navbar from '@/components/Navbar.vue'
// import SupplierTable from '@/components/SupplierTable.vue'
import { mapGetters } from 'vuex'
import MaterialVariantLocationListing from '../components/MaterialVariantLocationListing.vue'


export default {
  name: 'Home',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Sidebar,
    // eslint-disable-next-line vue/no-unused-components
    Navbar,
    // SupplierTable,
    MaterialVariantLocationListing,
  },
  data() {
    return {
      materialIdToShow: '',
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
  methods: {
    materialId(id) {
      this.materialIdToShow = id
    },
  },
}
</script>

<style scoped lang="scss">
.main{
    padding: 75px 15px 15px 120px;
  }
@media screen and (max-width: 1700px){
  .main{
    padding: 75px 15px 15px 90px;
  }
}
@media screen and (max-width: 1190px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}
</style>
